import { AboutMeSection } from "./styles";
import me from "../../assets/me-cat.jpg";
import AboutMeText from "../../components/AboutMeText";

const AboutMePage = () => {
  return (
    <AboutMeSection>
      <h2>About me</h2>
      <div className="main">
        <div className="left">
          <img src={me} alt="" />
        </div>
        <AboutMeText />
      </div>
    </AboutMeSection>
  );
};

export default AboutMePage;
